/* eslint-disable */
export default {
  sidebar: {
    title: 'İyi Finans',
    description: 'İyi Finans Branch Application',
    searchText: 'Search...'
  },
  buttons: {
    new: 'New',
    save: 'Save',
    delete: 'Delete',
    update: 'Update',
    edit: 'Edit',
    clear: 'Clear',
    done: 'Done',
    cancel: 'Cancel',
    openNewCampaign: 'Open New Campaign'
  },
  navbar: {
    title: 'İyi Finans Branch Application',
    searchText: 'Search...',
    stats: 'Stats',
    logout: 'Logout',
    someaction: 'Actions',
    action: 'Action',
    anotheraction: 'Other Action',
    somethingelse: 'Something Else',
    english: 'English',
    turkish: 'Turkish',
    screenfull: 'Full Screen',
    size: 'Text Size',
    languageChanged: 'Switch Language Success',
    dashboard: 'Dashboard',
    logOut: 'Logout'
  },
  usermenu: {
    profile: 'Profile',
    editprofile: 'Update',
    settings: 'Settings',
    name: 'Name & Surname',
    email: 'E-Mail',
    telno: 'Phone Number'
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All',
    refresh: 'Refresh'
  },
  route: {
    dashboard: 'Dashboard',
    dms: 'Document Management',
    portfolio: 'Portfolio',
    crmAdmin: 'Crm Administrator',
    parameterClassification: 'Classification',
    parameterGeo: 'Geo',
    parameterContactMechPurposeType: 'ContactMech Purpose',
    personCreate: 'Kişi',
    personList: 'Muhatap Listeleme',
    createPartyInformalOrganization: 'Organizasyon',
    personEdit: 'Gerçek Kişi İzleme',
    personDashboard: 'Müşteri Dashboard',
    tasklist: 'Task List',
    templatelist: 'Template List',
    templatecreate: 'Create New Template',
    templateedit: 'Update Template',
    processlist: 'Process List',
    processcreate: 'Create Process',
    bpm: 'Process',
    newtaskslist: 'New Task List',
    help: 'Help',
    userprofile: 'User Profile',
    editprofile: 'Edit Profile',
    settings: 'Settings',
    templateview: 'Template',
    process: 'Process',
    financemanagement: 'Finance Management',
    campaignlist: 'Campaign List',
    advancelist: 'WorkingCost Packages',
    grouplist: 'Maturity List',
    packagelist: 'Priority Òist',
    referencerulelist: 'Reference Rule List',
    versionlist: 'Version List',
    campaignusagelist: 'Campaign Usage List',
    packageusagelist: 'Priority Usage List',
    referenceusagelist: 'ReferenceRule Usage List',
    portfolioBranchMapList: 'Branch Portfolio Relation ',
    finance: 'Finance',
    orderedwizard: 'Ordered Wizard',
    freeplanwizard: 'FreePlanWizard',
    detailview: 'Campaign View',
    hr: 'Human Resources',
    newprocess: 'New Process',
    profile: 'Profile',
    usersettings: 'Settings',
    logOut: 'Exit',
    departmentCreate: 'Department List',
    roleCreate: 'Role List',
    employee: 'Employee',
    crm: 'Crm',
    newtask: 'Add Task',
    proposallist: 'Proposal List',
    proposalview: 'Proposal Detail',
    transactionlist: 'Transaction List',
    productlist: 'Product List',
    we: 'Work Effort',
    inventoryItem: 'Inventory',
    fixedAsset: 'Fixed Asset',
    weParameters: 'Parameters'
  },
  login: {
    title: 'İyi Finans Login',
    logIn: 'LOGIN',
    username: 'Username',
    password: 'Password',
    rememberMe: 'Remember Me',
    header1: 'LINE DETECTION METHOD',
    description1: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ac magna tellus. Vivamus sollicitudin, lectus ut rhoncus commodo',
    header2: 'FREE PLANNED METHOD',
    description2: 'Nulla at augue fringilla, sollicitudin metus dapibus, molestie ligula. Quisque lacinia dui sollicitudin rhoncus consequat.',
    header3: 'HOUSING VALUE INDEX MANAGEMENT',
    description3: ' Aliquam vel eros et massa sagittis scelerisque. Mauris imperdiet facilisis augue in scelerisque.',
    invalid_username_or_password: 'Username and/or Password is incorrect'
  },
  vtreeselect: {
    placeholder: '',
    noresults: 'Record not found'
  },
  errors: {
    500: 'Internal Server Error (500)',
    unknownloginerror: 'An error occured while logging',
    networkerror: 'Network error occured.'
  },
  errorPage: {
    title: 'Page not found',
    description: 'Please check that the page address you entered is correct. Click the button below to return to the main page and to send an error report.',
    home: 'Back to home',
    right: 'You are not allowed to go to this page'
  },
  notify: {
    alreadyExist: 'Record already exist. Still you can update the record from action buttons.',
    success: 'Save successfull.',
    error: 'Fail on save!',
    unknownError: 'İşlem esnasında hata oluştu',
    notDone: 'Progress canceled.',
    saveChanges: 'Save Changes',
    discardChanges: 'Discard Changes',
    passwordSixDigits: 'The Password cannot be less than 6 digits !',
    deleteRecord: 'Delete',
    deleteWarning: 'Delete Confirmation',
    delete: 'Delete',
    deleteCancel: 'Cancel',
    deleteCanceled: 'Delete canceled.',
    deleteSuccess: 'Delete successfull!',
    complate: 'Complate',
    edit: 'Edit',
    cancel: 'Cancel',
    ok: 'OK',
    warning: 'Warning',
    cancelNotify: 'Are you sure to discard changes?',
    returnList: 'Are you sure to return template list screen ?',
    yes: 'Yes',
    no: 'No'
  }
};
/* eslint-enable */